import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { nameToInitials } from '../helpers';
import { userInfoSelector } from '../state';

const UserAvatar = ({ sx = {} }) => {
  const { name } = useSelector(userInfoSelector) || { name: '' };
  const initials = nameToInitials(name);

  return (
    <Avatar
      sx={{
        backgroundColor: theme => theme.palette.primary.main,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: 'inherit',
          color: theme => theme.custom.avatarColor,
        }}
      >
        {initials}
      </Typography>
    </Avatar>
  );
};

export default UserAvatar;
